import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { DeviceService } from 'src/app/services/devices/device.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
    selector: 'app-anc-calendar',
    imports: [CommonModule, FormsModule, TranslateModule],
    templateUrl: './anc-calendar.component.html'
})
export class AncCalendarComponent  implements OnInit {

  @Input()
  allSettings=false;
  device : string = '';
  cfgData: any = {};

        successMessage: boolean = false;
        error: string= '';
        originalData: any;
        changesMade=false;
        statData: any = {};
        sunrise: string = '';
        sunset: string = ''
        cor


  constructor(private _aRoute: ActivatedRoute, public _deviceService : DeviceService, private _utilsService: UtilsService ) {      }


  ngOnInit(): void {

    this._aRoute.parent?.parent?.params
      .subscribe((params: Params) => this.device = params['serial']);

    this._deviceService.getModuleInfo(this.device, "calendar").subscribe(data=>{
      console.log('Calendar ', data);
      this.originalData = { ...data.cfg };
      this.cfgData = data.cfg;
      this.statData = data.stat;
console.log('mode1224 ' , this.cfgData.mode1224);

      if (this.cfgData?.mode1224 === undefined || this.cfgData?.mode1224 === null) {
        this.cfgData.mode1224 = 1;
      }
console.log('mode1224   ' , this.cfgData.mode1224);
console.log('corrSunrise ' , this.cfgData.corrSunrise );
console.log('corrSunset ' , this.cfgData.corrSunset );
      this.sunrise = this._utilsService.getDateFromMinutes(this.cfgData.corrSunrise);
      this.sunset = this._utilsService.getDateFromMinutes(this.cfgData.corrSunset);
      console.log('prueba minutos' , this._utilsService.getDateFromMinutes(120) );

      console.log('sunrise ', this.sunrise);
      console.log('sunset ', this.sunset);

    })

  }


  save(){}

}
